export default __webpack_public_path__ + "static/media/logout.9411730d.svg";